import { animate, state, style, transition, trigger } from '@angular/animations';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, EventEmitter, Output } from '@angular/core';
import { NavServiceService } from 'src/app/services/nav-service.service';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

@Component({
  selector: 'app-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.css'],
  animations: [
    trigger('subMenuShowHide', [
      state('in', style({
        height: 'auto',
        width: 'auto',
        margin: '0',
        padding: '0'
      })),
      state('out', style({
        opacity: 0,
        visibility : 'hidden',
        height: '0px',
        margin: '0',
        padding: '0'
      })),
      transition('in => out', animate('300ms')),
      transition('out => in', animate('300ms'))
    ]),
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(180deg)' })),
      transition('rotated => default', animate('100ms ease-out')),
      transition('default => rotated', animate('100ms ease-in'))
    ])
  ]
})
export class NavigationMenuComponent {

  @Output() onRouted: EventEmitter<any> = new EventEmitter<any>();
  menuList: any[] = [];
  displayPopMenu: boolean = false;
  popMenuList: any[] = [];
  tempPopParent: any = null;
  activePopParent: any = null;

  
  positions: ConnectedPosition[] = [
    {
      originX: 'end',     // anchor to the right edge of the parent
      originY: 'top',  // anchor to the bottom of the parent
      overlayX: 'start',    // align popover’s right edge
      overlayY: 'top'     // align popover’s top edge
    }
  ];
  activeOrigin?: CdkOverlayOrigin;

  
  constructor(
    public navService: NavServiceService
  ){}

  ngOnInit(){
    
    this.navService.getMenu().then((result: any[]) => { 
      this.menuList = result;
      this.menuList = this.menuList.map( (item: any) => {
        let flatMap = this.flattenMenu(item?.subMenus ?? []);
        let isActive = ((flatMap ?? []).findIndex( (sub: any) => sub?.routerLink == this.navService.activeSideBar) ) > -1;
        return {
          ...item,
          expanded: this.navService.activeSideBar == item?.routerLink || isActive,
        }
      });
    });
  }

  clickMenu(item: any){
    if (item?.subMenus == null)
    {
      this.navService.NavigateRoute('', item?.routerLink);
    }
    else
    {
      item.expanded = item?.expanded ? !item?.expanded : true;
    }
  }

  clickSub(parent: any, item: any, ev: any){
    if (item?.subMenus == null){
      this.activePopParent = null;
      this.onRouted.emit(true);
      this.navService.NavigateRoute(parent?.routerLink, item?.routerLink);
    }
    else {
      this.tempPopParent = item;
      this.activeOrigin = ev;
      this.popMenuList = [...item?.subMenus]
      this.displayPopMenu = true;
    }
  }

  clickPop(item: any) {
    this.activePopParent = this.tempPopParent;
    this.onRouted.emit(true);
    this.navService.NavigateRoute(this.activePopParent?.routerLink, item?.routerLink);
    this.displayPopMenu = false;
  }

  flattenMenu(menuList: any[]): any[] {
    return menuList.flatMap(menu => [
      menu,
      ...(menu.subMenus ? this.flattenMenu(menu.subMenus) : [])
    ]);
  }

  expandAll(){
    this.menuList = this.menuList.map( (item: any) => {
      return {
        ...item,
        expanded: true
      }
    })
  }

}
